module.exports = {"id":"183519","name":"Nacer Barazite","rating":"73","photo":"./data/images/photos/3/183519.png","club":{"name":"Yeni Malatyaspor","logo":"./data/images/clubs/YeniMalatyaspor.png"},"positions":["MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NacerBarazite0.json
// module id = 3117
// module chunks = 0